<template>
  <v-dialog :value="value" @input="$emit('input')" max-width="500px" persistent>
    <v-card>
      <v-card-title class="title">When did this campaign concluded?</v-card-title>
      <v-card-text class="mt-3 body-2">
        <v-form ref="quarterForm" v-model="valid" lazy-validation>
          <v-select
            :items="defaultYears"
            label="Year"
            v-model="data.year"
            outlined
            dense
            required
            :rules="MessageRules"
          ></v-select>
          <v-select
            v-model="data.quarter"
            :items="quarters"
            item-value="name"
            item-text="title"
            label="Quarter"
            dense
            outlined
            required
            :rules="MessageRules"
          ></v-select>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn color="red" id="close" text @click.native="$emit('input')">Close</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="green" text @click="save()">Save</v-btn>
      </v-card-actions>
    </v-card>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="180"
      height.number="180"
    />
  </v-dialog>
</template>
<script>
import campaignAPIs from '../Campaign/campaignAPIs';
// import pairingAPIs from '../Pairing/pairingAPIs';
// // import userAPIs from '../User/userAPIs';
// import campaignConfig from '../Campaign/config';
import config from '@/config';
import { mapState } from 'vuex';
// import moment from 'moment'
import Loading from 'vue-loading-overlay';
export default {
  name: 'UpdatePaymentInfoModal',
  components: {
    Loading
  },
  props: {
    value: Boolean,
    campaignID: String,
    multipleCampaignIds: Array
  },
  data () {
    return {
      valid: true,
      isLoading: false,
      data: {
        quarter: '',
        year: ''
      },
      defaultYears: [2026, 2025, 2024, 2023, 2022],
      quarters: [
        {
          name: 'Q1',
          title: 'QUARTER 1'
        },
        {
          name: 'Q2',
          title: 'QUARTER 2'
        },
        {
          name: 'Q3',
          title: 'QUARTER 3'
        },
        {
          name: 'Q4',
          title: 'QUARTER 4'
        }
      ],
      MessageRules: [value => !!value || 'Required.']
    }
  },
  async mounted() {
  },
  computed: {
    ...mapState({
      campaignUpdated: state => state.campaign.campaignUpdated,
      savedCampaignCogs: state => state.campaign.savedCampaignCogs
    }),
    currentUserRole: function () {
      return Number(this.$store.state.user.role);
    },
    currentUserID: function () {
      return this.$store.state.user.id;
    }
  },
  watch: {
  },
  methods: {
    save() {
      if (!this.$refs.quarterForm.validate()) {
        return;
      }
      this.$swal({
        title: 'Double Check!',
        text: 'Make sure you filled all the required information',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result) => {
        if (result.value) {
          this.isLoading = true
          let campaignIds = []
          if (this.multipleCampaignIds && this.multipleCampaignIds.length) {
            campaignIds = Object.assign([], this.multipleCampaignIds)
          } else {
            campaignIds.push(this.campaignID)
          }
          for (let campaignID of campaignIds) {
            let campaign = await campaignAPIs.getCampaign(campaignID)
            let yearQuarter = `${this.data.year}${this.data.quarter}`
            if (campaign) {
              if (campaign.activeYear) {
                if (Array.isArray(campaign.activeYear)) {
                  if (!campaign.activeYear.includes(this.data.year)) {
                    campaign.activeYear.push(this.data.year)
                  }
                }
              } else {
                campaign.activeYear = [this.data.year]
              }
            }
            // campaign update
            let data = [
              Object.assign({}, {
                id: campaign.id,
                activeYear: campaign.activeYear,
                yearQuarter: yearQuarter.replace('20', ''),
                lockedCOGS: true,
                status: config.campaignStatus.REVIEW
              })
            ]
            // Submit request to save archived campaign data
            await this.$store.dispatch('campaign/updateCampaignByIds', data)
          }
          // // saved in campaign cogs
          // await this.$store.dispatch('campaign/updateCampaignCogs', data)
          this.isLoading = false
          if (this.campaignUpdated) {
            this.$emit('updated')
            this.close()
            this.$swal({
              text: 'Successfully Saved.',
              type: 'success'
            });
          }
        }
      })
    },
    resetForm() {
      this.data = {
        quarter: ''
      }
      this.valid = true
    },
    close() {
      this.$emit('input')
    }
  }
};
</script>



// WEBPACK FOOTER //
// UpdateCampaignQuarterModal.vue?e45f72da